import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { isGlobalAdmin } from "../utils/util";
import { useGetCompanies } from "../hooks/companyHooks";
import { ChevronDown } from "lucide-react";
import { useParams } from "react-router-dom";
import { EmployeeContext } from "../context/EmployeeContext";
import { Company } from "../types";
export const AdminCompanyFilter = ({
    currentCompanyId,
    onChange,
    width = "85%",
}: {
    currentCompanyId: string;
    onChange: (newCompanyId: string) => void;
    width?: string;
}) => {
    const { data: companies } = useGetCompanies();
    const [selected, setSelected] = useState(currentCompanyId);
    const { companyId } = useParams();
    const { employee } = useContext(EmployeeContext);
    const onChangeSelected = (newId: string) => {
        setSelected(newId);
        onChange(newId);
        setTimeout(() => {
            const selectElement = document.getElementById("filter-company-select");
            selectElement?.focus();
        }, 100);
    };

    if (!isGlobalAdmin) {
        return null;
    }
    const getVisibleCompanies = (): Company[] => {
        if (!companies) return [];

        const isSoecoMain = companies.some(
            c => c.id === "850d488b-c78c-4db7-9b8e-5b728eebbbe9" && c.id === employee.companyId,
        );

        if (isSoecoMain) {
            return companies;
        }

        const adminCompany = companies.find(c => c.id === employee.companyId);
        if (!adminCompany) return [];
        let visible = companies.filter(
            c =>
                c.id === adminCompany.id ||
                c.superCompany === adminCompany.id ||
                c.createdBy === adminCompany.id,
        );

        if (employee.role === "superAdmin") {
            const firstLevelIds = visible.map(c => c.id);
            const secondLevel = companies.filter(c => firstLevelIds.includes(c.superCompany ?? ""));
            visible = [...visible, ...secondLevel];
        }

        const unique = Array.from(new Map(visible.map(c => [c.id, c])).values());

        return unique;
    };

    const currentCompanies = getVisibleCompanies();

    useEffect(() => {
        setSelected(currentCompanyId);
    }, [currentCompanyId]);

    return (
        <FormControl sx={{ width: width }}>
            <InputLabel id="filter-company">Acting Company</InputLabel>
            {companies && (
                <>
                    <Select
                        id="filter-company-select"
                        labelId="filter-company"
                        label="Acting Company"
                        value={selected}
                        onChange={event => onChangeSelected(event.target.value)}
                        IconComponent={ChevronDown}
                        sx={{
                            fontFamily: "'Yllw Sans a1 241219', sans-serif",
                            fontSize: "16px",
                            fontWeight: "400",
                        }}
                        aria-label="Acting Company, combo box"
                    >
                        {currentCompanies.map(company => (
                            <MenuItem key={company.id} value={company.id}>
                                {company.name}
                            </MenuItem>
                        ))}
                    </Select>

                    <span
                        aria-live="polite"
                        style={{
                            position: "absolute",
                            left: "-9999px",
                            height: 0,
                            overflow: "hidden",
                        }}
                    >
                        {currentCompanies.find(c => c.id === selected)?.name}
                    </span>
                </>
            )}
        </FormControl>
    );
};
